import Icon from '../components/Icon.vue'

Icon.register({
  'umbrella-beach': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M115.4 136.9L217.5 174.1C252.7 92.5 303.7 29.8 356.5 0.4 260.6-4.5 167.7 37.3 108 112.2 101.3 120.6 105.3 133.2 115.4 136.9zM247.6 185.1L486.1 271.9C521.9 150.5 504.8 40.2 443.5 17.9 436.1 15.2 428.4 13.9 420.4 13.9 362.4 13.9 292.1 83.1 247.6 185.1zM521.5 60.5C527.7 76.8 532.3 95.1 534.7 115.7 540.4 165.6 533.3 223.9 515.7 282.7L618.4 320C628.4 323.7 639.7 316.6 639.9 305.9 642.2 210.2 598 118.4 521.5 60.5zM560 448H321.1L386 269.5 325.9 247.6 253 448H16C7.2 448 0 455.1 0 464V496C0 504.8 7.2 512 16 512H560C568.8 512 576 504.8 576 496V464C576 455.1 568.8 448 560 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/umbrella-beach.js
// module id = 827N
// module chunks = 144